/**
 * Created by Allan on 2021/04/09.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/user',
        meta:{
            title:'用户管理',
            icon:'el-icon-user-solid',
            menuId:'2'
        },
        component:Frame,
        children:[
            {
                path:'index',
                name:'userList',
                meta:{
                    title:'用户列表',
                    keepAlive:true,
                    menuId:'4'
                },
                component:resolve => require(['@/views/user/list/index'], resolve)
            },
            {
                path:'details/:userId/:name',
                name:'userDetails',
                meta:{
                    title:'用户详情'
                },
                hidden:true,
                component:resolve => require(['@/views/user/details/index'], resolve)
            },
            {
                path:'blacklist',
                name:'blacklist',
                meta:{
                    title:'黑名单列表',
                    keepAlive:true,
                    menuId:'6'
                },
                component:resolve => require(['@/views/user/blackList/index'], resolve)
            },
            {
                path:'whitelist',
                name:'whiteList',
                meta:{
                    title:'白名单列表',
                    keepAlive:true,
                    menuId:'7'
                },
                component:resolve => require(['@/views/user/whiteList/index'], resolve)
            }
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/user.js